import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button } from '@mui/material';
import React from 'react';
import { useMissionsTranslation } from '../hooks';
export const ShowMoreButton = ({ onLoadMore }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Button, { sx: {
            alignSelf: 'center',
            width: { xs: '100%', sm: 'auto' },
        }, variant: 'outlined', "data-test": 'show-more-button', startIcon: React.createElement(KeyboardArrowDownIcon, null), onClick: onLoadMore }, t('missions.showMore')));
};
